import { Directive, TemplateRef, inject } from '@angular/core';
import type { GridCellEditContext } from '../core/interfaces/grid-context.types';

/**
 * Marca um `ng-template` como editor customizado de célula de uma coluna.
 * Uso: `<ng-template companyCellEditDef let-control="control">...</ng-template>`
 */
@Directive({
  selector: '[companyCellEditDef]',
})
export class CompanyCellEditDefDirective<T = unknown> {
  readonly template = inject(TemplateRef<GridCellEditContext<T>>);
}
